import { render, staticRenderFns } from "./DetallePlanResumen.vue?vue&type=template&id=5135e276&scoped=true&"
import script from "./DetallePlanResumen.vue?vue&type=script&lang=js&"
export * from "./DetallePlanResumen.vue?vue&type=script&lang=js&"
import style0 from "./DetallePlanResumen.vue?vue&type=style&index=0&id=5135e276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5135e276",
  null
  
)

export default component.exports